import { makeAutoObservable } from 'mobx';
import _ from 'lodash';

class FlowState {
  history;
  match;
  localization = {};

  deleteModalOpen = false;
  steps;
  onStepSubmitted;
  onDeleted;
  onStepChanged;
  nextEnabled = true;

  constructor({history}) {
    makeAutoObservable(this, {
      history: false
    });

    this.history = history;
  }

  updateProps({localization, steps, onStepSubmitted, onDeleted, onStepChanged, nextEnabled, match}) {
    this.steps = steps;
    this.onStepSubmitted = onStepSubmitted;
    this.onDeleted = onDeleted;
    this.onStepChanged = onStepChanged;
    this.nextEnabled = nextEnabled;
    this.match = match;

    _.merge(this.localization, localization);
  }

  async submitStep() {
    const nextStep = this.steps.nextStep();

    const nextLocation = await this.__continue();
    if (nextLocation === false || !nextStep) return;

    const nextPath = _.get(nextLocation, 'nextLocation');

    this.history.push(nextPath || `${this.match.url}/${this.steps.path(nextStep)}`);
  }

  goBack() {
    this.history.push(`${this.match.url}/${this.steps.path(this.steps.previousStep())}`);
  }

  async __continue() {
    if (!this.onStepSubmitted) return true;

    return this.onStepSubmitted(this.steps.activeStep);
  }

  async setCurrentStep(step) {
    this.steps.setActiveStep(step);

    if (!this.onStepChanged) return null;

    return this.onStepChanged(step);
  }

  async openDeleteModal() {
    this.deleteModalOpen = true;
  }

  closeDeleteModal() {
    this.deleteModalOpen = false;
  }

  async confirmDeletion() {
    return this.onDeleted();
  }

  get backEnabled() {
    return !this.steps.activeStepIsFirst();
  }

  get deleteEnabled() {
    return !!this.onDeleted;
  }

  get isFinalStep() {
    return this.steps.activeStepIsLast();
  }
}

export default FlowState;
